module.exports = __webpack_public_path__ + "static/google-play-badge-6f741ca81124330c6ddd422f471427e3.png";